export default __webpack_public_path__ + "static/underline-universe-mobile-c39055629bdc9961dbeaa069e4a6f004.svg";